import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-social-activities',
  templateUrl: './social-activities.component.html',
  styleUrls: ['./social-activities.component.scss']
})
export class SocialActivitiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
